import { render, staticRenderFns } from "./FPageSalesFuels.vue?vue&type=template&id=15afa799&"
import script from "./FPageSalesFuels.vue?vue&type=script&lang=js&"
export * from "./FPageSalesFuels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports